import React from "react";
// import '../../assets/js/layout.js';
//import { useNavigate } from "react-router-dom";
// import '../../assets/libs/bootstrap/js/bootstrap.bundle.min.js';
// import { AuthData } from "../../auth/AuthWrapper";
import {PRODUCT_NAME} from "../../utils/config_mapping"
export const RenderHeader = () => {
    // const { isLoggedIn, logout } = AuthData();
    // const [isFullscreen, setIsFullscreen] = useState(false); // State to track fullscreen status
  //  const navigate = useNavigate();
    // const logout = () => {
    //     localStorage.setItem("login",0)
    //     navigate("/logout")
    //     window.location.reload(); // Force a full page reload to apply changes
    // }
    // const fullscreen = () =>{
    //     const element = document.documentElement; // Fullscreen for the whole page
    //     if (!document.fullscreenElement &&    // Standard API
    //         !document.webkitFullscreenElement && // Safari/Old WebKit
    //         !document.mozFullScreenElement &&   // Old Firefox
    //         !document.msFullscreenElement) {   // Old IE/Edge
    //         // Enter fullscreen
    //         if (element.requestFullscreen) {
    //             element.requestFullscreen();
    //         } else if (element.webkitRequestFullscreen) { // Safari/Old WebKit
    //             element.webkitRequestFullscreen();
    //         } else if (element.mozRequestFullScreen) { // Old Firefox
    //             element.mozRequestFullScreen();
    //         } else if (element.msRequestFullscreen) { // Old IE/Edge
    //             element.msRequestFullscreen();
    //         }
    //         setIsFullscreen(true);
    //     } else {
    //         // Exit fullscreen
    //         if (document.exitFullscreen) {
    //             document.exitFullscreen();
    //         } else if (document.webkitExitFullscreen) { // Safari/Old WebKit
    //             document.webkitExitFullscreen();
    //         } else if (document.mozCancelFullScreen) { // Old Firefox
    //             document.mozCancelFullScreen();
    //         } else if (document.msExitFullscreen) { // Old IE/Edge
    //             document.msExitFullscreen();
    //         }
    //         setIsFullscreen(false); // Update state to not fullscreen
    //     }
    // }
    // const themeChange = () => {
    //     const htmlElement = document.documentElement; // Refers to the <html> tag
    //     const currentTheme = htmlElement.getAttribute('data-bs-theme');
    //     // Toggle between 'light' and 'dark'
    //     const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    //     htmlElement.setAttribute('data-bs-theme', newTheme);
    //     htmlElement.setAttribute('data-bs-theme', newTheme);
    //     if (currentTheme) {
    //         document.body.classList.remove('dark-theme');
    //         document.body.classList.add('light-theme');
    //     } else {
    //         document.body.classList.remove('light-theme');
    //         document.body.classList.add('dark-theme');
    //     }
    // };
     return (
<header id="page-topbar" className="d-none">
    <div className="layout-width">
        <div className="navbar-header">
            <div className="d-flex">
                <div className="navbar-brand-box horizontal-logo">
                    <a href="index.html" className="logo logo-dark">
                        <span className="logo-sm">
                        <h3 className="text-primary" style={{fontSize: "18px",marginBottom:"0px"}}><span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} /></h3>
                        </span>
                        <span className="logo-lg">
                        <h3 className="text-primary" style={{fontSize: "18px",marginBottom:"0px"}}><span dangerouslySetInnerHTML={{ __html: PRODUCT_NAME }} /></h3>
                        </span>
                    </a>
                    {/* <a href="#" className="logo logo-light">
                        <span className="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                            <img src="assets/images/logo-light.png" alt="" height="17" />
                        </span>
                    </a> */}
                </div>
          {/* <nav className="navbar navbar-expand-lg">
  <div className="container-fluid">
    <a className="navbar-brand" href="/document-list"><h3 className="text-primary" style={{fontSize: "18px",marginBottom:"0px"}}>ContractGenie<sup>TM</sup></h3></a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="/document-list"><i className="ri-file-list-line fs-22"></i>Documents</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#"><i className="ri-dashboard-line  fs-22"></i>Dashboard</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#"><i className="ri-file-search-line fs-22"></i>Repository Search</a>
        </li>
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#"><i className="ri-alert-line fs-22"></i>Alerts</a>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="ri-settings-5-fill fs-22"></i>Admin
          </a>
          <ul className="dropdown-menu">
            <li><a className="dropdown-item" href="#">Action</a></li>
            <li><hr className="dropdown-divider" /></li>
            <li><a className="dropdown-item" href="#">Another action</a></li>
            <li><hr className="dropdown-divider" /></li>
            <li><a className="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
      </ul>
    
    </div>
  </div>
</nav> */}

                {/* <form className="app-search d-none d-md-block">
                    <div className="position-relative">
                        <input type="text" className="form-control" placeholder="Search..." autocomplete="off" id="search-options" value="" />
                        <span className="mdi mdi-magnify search-widget-icon"></span>
                        <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none" id="search-close-options"></span>
                    </div>
                    <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                        <div data-simplebar="init" style={{ maxHeight: '320px' }}><div className="simplebar-wrapper" style={{margin: '0px'}}><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer"></div></div><div className="simplebar-mask"><div className="simplebar-offset" style={{right: "0px", bottom: "0px"}}><div className="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{height:"auto",overflow: "hidden;"}}><div className="simplebar-content" style={{padding:"0px;"}}>
                            <div className="dropdown-header">
                                <h6 className="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                            </div>

                            <div className="dropdown-item bg-transparent text-wrap">
                                <a href="index.html" className="btn btn-soft-secondary btn-sm rounded-pill">how to setup <i className="mdi mdi-magnify ms-1"></i></a>
                                <a href="index.html" className="btn btn-soft-secondary btn-sm rounded-pill">buttons <i className="mdi mdi-magnify ms-1"></i></a>
                            </div>
                            <div className="dropdown-header mt-2">
                                <h6 className="text-overflow text-muted mb-1 text-uppercase">Pages</h6>
                            </div>

                            <a href="javascript:void(0);" className="dropdown-item notify-item">
                                <i className="ri-bubble-chart-line align-middle fs-18 text-muted me-2"></i>
                                <span>Analytics Dashboard</span>
                            </a>

                            <a href="javascript:void(0);" className="dropdown-item notify-item">
                                <i className="ri-lifebuoy-line align-middle fs-18 text-muted me-2"></i>
                                <span>Help Center</span>
                            </a>

                            <a href="javascript:void(0);" className="dropdown-item notify-item">
                                <i className="ri-user-settings-line align-middle fs-18 text-muted me-2"></i>
                                <span>My account settings</span>
                            </a>

                            <div className="dropdown-header mt-2">
                                <h6 className="text-overflow text-muted mb-2 text-uppercase">Members</h6>
                            </div>

                            <div className="notification-list">
                                <a href="javascript:void(0);" className="dropdown-item notify-item py-2">
                                    <div className="d-flex">
                                        <img src="assets/images/users/avatar-2.jpg" className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                        <div className="flex-grow-1">
                                            <h6 className="m-0">Angela Bernier</h6>
                                            <span className="fs-11 mb-0 text-muted">Manager</span>
                                        </div>
                                    </div>
                                </a>
                                <a href="javascript:void(0);" className="dropdown-item notify-item py-2">
                                    <div className="d-flex">
                                        <img src="assets/images/users/avatar-3.jpg" className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                        <div className="flex-grow-1">
                                            <h6 className="m-0">David Grasso</h6>
                                            <span className="fs-11 mb-0 text-muted">Web Designer</span>
                                        </div>
                                    </div>
                                </a>
                                <a href="javascript:void(0);" className="dropdown-item notify-item py-2">
                                    <div className="d-flex">
                                        <img src="assets/images/users/avatar-5.jpg" className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                        <div className="flex-grow-1">
                                            <h6 className="m-0">Mike Bunch</h6>
                                            <span className="fs-11 mb-0 text-muted">React Developer</span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div></div></div></div><div className="simplebar-placeholder" style={{width: "0px;", height: "0px;"}}></div></div><div className="simplebar-track simplebar-horizontal" style={{visibility: "hidden;"}}><div className="simplebar-scrollbar" style={{width:"0px;",display:"none;"}}></div></div><div className="simplebar-track simplebar-vertical" style={{visibility: "hidden;"}}><div className="simplebar-scrollbar" style={{height:"0px",display:"none;"}}></div></div></div>

                        <div className="text-center pt-3 pb-1">
                            <a href="pages-search-results.html" className="btn btn-primary btn-sm">View All Results <i className="ri-arrow-right-line ms-1"></i></a>
                        </div>
                    </div>
                </form> */}
            </div>
            {/* <div className="d-flex align-items-center">
                <div className="dropdown d-md-none topbar-head-dropdown header-item">
                    <button type="button" className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="bx bx-search fs-22"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
                        <form className="p-3">
                            <div className="form-group m-0">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                                    <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="ms-1 header-item d-none d-sm-flex">
                    <button onClick={fullscreen} type="button" className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle" data-toggle="fullscreen">
                    {isFullscreen ? (
                                    <i className="bx bx-exit-fullscreen fs-22"></i>
                                ) : (
                                    <i className="bx bx-fullscreen fs-22"></i>
                                )}

                    </button>
                </div>
                <div className="ms-1 header-item d-none d-sm-flex">
                    <button onClick={themeChange} type="button" className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle light-dark-mode">
                        <i className="bx bx-moon fs-22"></i>
                    </button>
                </div>
                <img style={{backgroundColor:"#000",height:"25px"}} src="data:image/webp;base64,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" alt="" />
                <div className="dropdown ms-sm-3 header-item topbar-user">
                    <button type="button" className="btn material-shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="d-flex align-items-center">
                            <i className="bx bx-user-circle  fs-22"></i>
                            <span className="text-start ms-xl-2">
                                <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">Rajan</span>
                                <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">UI Developer</span>
                            </span>
                        </span>
                    </button>
                    <div className="dropdown-menu dropdown-menu-end">
                        <h6 className="dropdown-header">Welcome Rajan!</h6>
                        <a className="dropdown-item" href="pages-profile.html"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Profile</span></a>
                        <div className="dropdown-divider"></div>
                        <a className="dropdown-item" href="pages-profile-settings.html"><i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Settings</span></a>
                        <a className="dropdown-item" onClick={logout} href="javscript:void()"><i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span className="align-middle" data-key="t-logout">Logout</span></a>
                    </div>
                </div>
            </div> */}
        </div>
    </div>
</header>
     )
}